import translations from "./translations";
import React, {useEffect, useState} from "react";
import useCustomTranslation from "core/customTranslation";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import {Spinner} from "react-bootstrap";

const TableNfcReport = ({device}) => {
    const {t: _TC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axiApi
            .get("/api/nfc/reports/quamtra/", {params: {device_uuid: device.uuid}})
            .then((response) => {
                if (response.data.status) {
                    setReport(response.data.items);
                } else {
                    Alert.warning("Error admin", "Report no encontrado");
                }
            })
            .catch((error) => {
                console.error("Error fetching NFC report:", error);
                Alert.error("Error admin", "No se pudo obtener el informe NFC");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [device.uuid]);

    if (loading) {
        return (
            <div className="text-center p-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">{_TC("loading") || "Loading..."}</p>
            </div>
        );
    }

    return (
        <>
            <pre
                style={{
                    height: "450px",
                    fontFamily: "SF Mono, Monaco, Consolas, monospace",
                    fontSize: "16px",
                    margin: 0,
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                    backgroundColor: "#fff",
                    padding: "1rem",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    overflow: "auto",
                }}>
                {report?.report || _TC("no_report_available")}
            </pre>
        </>
    );
};
export default TableNfcReport;
